import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';
export const TranscriptMessageSchema = z.object({
    role: z.enum(['system', 'interviewer', 'participant', 'unknown']),
    providerRole: z.string().min(1).optional(),
    content: z.string(),
    timestamp: IsoDateTimeSchema,
    offsetSeconds: z.number().nonnegative().optional(),
});
export const AnswerSchema = z.object({
    questionId: z.string().min(1),
    questionText: z.string().min(1),
    mainAnswer: z.string().min(1),
    followUpAnswer: z.string().optional(),
    answeredAt: IsoDateTimeSchema,
});
export const SaveTranscriptRequestSchema = z.object({
    answers: z.array(AnswerSchema),
    transcript: z.array(TranscriptMessageSchema),
    completedAt: IsoDateTimeSchema.optional(),
});
export const TranscriptResponseSchema = z.object({
    sessionId: UuidSchema,
    projectId: UuidSchema,
    configVersion: z.number().multipleOf(1).nonnegative(),
    answers: z.array(AnswerSchema),
    transcript: z.array(TranscriptMessageSchema),
    completedAt: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
export const ProviderTranscriptResponseSchema = z.record(z.string(), z.unknown());
export const ProviderTranscriptBackfillRequestSchema = z
    .object({
    sessionIds: z.array(UuidSchema).min(1).max(100),
    forceRefetchFromProvider: z.boolean().optional(),
})
    .strict();
export const ProviderTranscriptBackfillItemSchema = z.object({
    sessionId: UuidSchema,
    status: z.enum([
        'backfilled',
        'skipped_missing_call_id',
        'skipped_missing_provider_transcript',
        'skipped_empty_transcript',
        'requeued',
        'failed',
    ]),
    source: z.enum(['stored_blob', 'provider', 'quality_processing']).optional(),
    transcriptMessages: z.number().multipleOf(1).nonnegative().optional(),
    error: z.string().optional(),
});
export const ProviderTranscriptBackfillResponseSchema = z.object({
    summary: z.object({
        sessions: z.number().multipleOf(1).nonnegative(),
        backfilled: z.number().multipleOf(1).nonnegative(),
        skippedMissingCallId: z.number().multipleOf(1).nonnegative(),
        skippedMissingProviderTranscript: z.number().multipleOf(1).nonnegative(),
        skippedEmptyTranscript: z.number().multipleOf(1).nonnegative(),
        failed: z.number().multipleOf(1).nonnegative(),
        requeued: z.number().multipleOf(1).nonnegative().optional(),
    }),
    items: z.array(ProviderTranscriptBackfillItemSchema),
});
//# sourceMappingURL=Transcripts.js.map